import moment from 'moment'

export const getDifference = (date, relativeDate) => moment(date).diff(relativeDate, 'days')

export const getDifferenceText = (date, relativeDate, withoutSuffix) =>
  getDifference(date, relativeDate) === 0 ? 'today' : moment(date).from(relativeDate, withoutSuffix)
